import type { SelectInputOption } from '@interstate/components/SelectInput';

export const productTypeOptions = [
    { label: 'APAY', value: 'APAY' },
    { label: 'APP', value: 'APP' },
    { label: 'BUNDLE', value: 'BUNDLE' },
    { label: 'CLAH', value: 'CLAH' },
    { label: 'CLD', value: 'CLD' },
    { label: 'CREDIT', value: 'CREDIT' },
    { label: 'DBT', value: 'DBT' },
    { label: 'ETCH', value: 'ETCH' },
    { label: 'EWT', value: 'EWT' },
    { label: 'FPP', value: 'FPP' },
    { label: 'GAP', value: 'GAP' },
    { label: 'HZRD', value: 'HZRD' },
    { label: 'ID', value: 'ID' },
    { label: 'KEY', value: 'KEY' },
    { label: 'LOY', value: 'LOY' },
    { label: 'LWT', value: 'LWT' },
    { label: 'MAINT', value: 'MAINT' },
    { label: 'OTHER', value: 'OTHER' },
    { label: 'PDR', value: 'PDR' },
    { label: 'PPM', value: 'PPM' },
    { label: 'RA', value: 'RA' },
    { label: 'RECOV', value: 'RECOV' },
    { label: 'SPOT', value: 'SPOT' },
    { label: 'THEFT', value: 'THEFT' },
    { label: 'TWL', value: 'TWL' },
    { label: 'VPP', value: 'VPP' },
    { label: 'VSC', value: 'VSC' },
    { label: 'VSCMAINT', value: 'VSCMAINT' },
    { label: 'WSHLD', value: 'WSHLD' }
] as SelectInputOption[];

export const profitLocationOptions = [
    { label: 'Front', value: 'Front' },
    { label: 'Back', value: 'Back' }
] as SelectInputOption[];

export enum DATA_TESTID_INPUT_PREFIX {
    PRODUCT_NAME = 'manual-vpp-product-name-',
    PRODUCT_TYPE = 'manual-vpp-product-type-',
    PRODUCT_CODE = 'manual-vpp-product-code-',
    PRODUCT_COST = 'manual-vpp-product-cost-',
    PROFIT_LOCATION = 'manual-vpp-profit-',
    PRODUCT_PRICE = 'manual-vpp-product-price-',
    MARKUP_VALUE = 'manual-vpp-markup-'
}
